import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { BrandLogo } from './BrandLogo';
import 'swiper/css';

const brands = [
  {
    name: 'Samsung',
    logo: '/assets/brand-logos/black-samsung-logo-png-21.png'
  },
  {
    name: 'LG',
    logo: '/assets/brand-logos/LG-Logo-2014-present.png'
  },
  {
    name: 'Miele',
    logo: '/assets/brand-logos/miele-logo.png'
  },
  {
    name: 'Whirlpool',
    logo: '/assets/brand-logos/OIP (1) copy.jpeg'
  },
  {
    name: 'Speed Queen',
    logo: '/assets/brand-logos/OIP.jpeg'
  }
];

export function BrandCarousel() {
  return (
    <section className="bg-white py-8 border-y border-gray-100">
      <div className="container mx-auto">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={60}
          slidesPerView={4}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 40
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 60
            }
          }}
          className="brand-carousel px-12"
        >
          {brands.map((brand, index) => (
            <SwiperSlide key={index} className="flex items-center justify-center">
              <BrandLogo name={brand.name} logo={brand.logo} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}